import { CLASS_NAMES } from './constants';
import EnquiryWorkDetailsFormFieldsWorkDescription from './Description';
import EnquiryWorkDetailsFormFieldsWorkUrgency from './Urgency';
import EnquiryWorkDetailsFormFieldsWorkWorkType from './WorkType';

const EnquiryWorkDetailsFormFieldsWork: React.FunctionComponent = function () {
  return (
    <div className="flex flex-col">
      <h1 className={CLASS_NAMES.header}>What work needs doing?</h1>
      <h3 className={CLASS_NAMES.subheader}>
        Select the type fo work you need from the types of work we offer, and
        let us know when is best to contact you
      </h3>
      <EnquiryWorkDetailsFormFieldsWorkWorkType />
      <EnquiryWorkDetailsFormFieldsWorkDescription />
      <EnquiryWorkDetailsFormFieldsWorkUrgency />
    </div>
  );
};

export default EnquiryWorkDetailsFormFieldsWork;
